import { Button, Table, Input, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import "../assets/style/TableComponent.css";
import { ColumnHeaderType, LoggedUserType } from "../utils/Types";
import { getTableItemClickClass } from "../utils/Util";
import { findValue } from "../utils/TableHelper";
import { CLICK_ACTIONS, STATUS } from "../utils/Constant";
import { useEffect, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { loginSelector } from "../redux/slices/loginSlice";
import { useSelector } from "react-redux";

const TableComponent = (props: any) => {
  const [dropdownOpen, setDropdownOpen] = useState<{ [key: string]: boolean }>({});
  const user: LoggedUserType = useSelector(loginSelector).user;

  useEffect(() => {
    if (props?.selectAll) {
      const allIds = props?.data?.map((record: any) => record?.grievanceId);
      props?.setSelectedRows && props?.setSelectedRows(allIds);
    } else if (props?.selectAll === false) {
      props?.setSelectedRows && props?.setSelectedRows([]);
    }
  }, [props?.selectAll, props?.data]);

  useEffect(() => {
    setTimeout(()=>{
      const allIds = props?.data?.map((record: any) => record?.grievanceId);
      props?.selectAll && props?.setSelectedRows(allIds);
    },500)
  },[])

  useEffect(() => {
    let flag;
    for(let i = 0; i < props?.data?.length; i++) {
      flag = !props?.selectedRows?.includes((props?.data[i]?.grievanceId)) ? undefined : true;
      if(!flag){
        break;
      }
    }
    props?.setSelectAll && props?.setSelectAll(flag);
  },[props?.selectedRows,  props?.data])

  const toggleDropdown = (column: string) => {
    setDropdownOpen({
      ...dropdownOpen,
      [column]: !dropdownOpen[column],
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === '#') {
      event.preventDefault();
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>, column: string) => {
    const inputValue = event.target.value;
    const term = inputValue.replace(/#/g, '');
    const currentValue = props?.searchTerms?.[column] || '';
    if (term !== currentValue) {
      props?.setSearchTerms({
        ...props?.searchTerms,
        [column]: term,
      });
    }
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    props?.setSelectAll && props?.setSelectAll(event.target.checked);
  };

  const handleSelectRow = (id: string) => {
    props?.setSelectedRows && props.setSelectedRows((prevSelectedRows: any) =>
      prevSelectedRows?.includes(id)
        ? prevSelectedRows?.filter((rowId: any) => rowId !== id)
        : [...prevSelectedRows, id]
    );
  };

  const getTableTd = (
    headerItem: ColumnHeaderType,
    item: any,
  ) => {
    return (
      <>
        {headerItem.action === CLICK_ACTIONS.VIEW_DOCUMENT ? (
          <Button className="viewButton"> View </Button>
        ) : headerItem.action === CLICK_ACTIONS.DELETE_USER ? (
          //<span className="td-span w-100"> Modify </span>
        <IconButton disabled={!user?.permissions?.includes('delete-user')} >
          <span>
            <img 
              src={require('../assets/img/delete.svg').default}
              alt="Delete"
              className="delete-icon"
            />
          </span>
        </IconButton>
        ) : headerItem.action === CLICK_ACTIONS.SET_PERMISSIONS ? (
          <Input 
            type="checkbox" 
            className="custom-checkbox"
            checked={item.getValues(item.formControl)}
            onChange={(e: any) => {
              item.onChangeInput(item.formControl, e.target.checked);
            }}
          />
        ) : headerItem.action === CLICK_ACTIONS.DELETE_GRIEVANCE? (
          <span>
            <img src={require('../assets/img/delete.svg').default}></img>
          </span>
        ) : headerItem.action === CLICK_ACTIONS.MODIFY_ROLE? (
          <>
            <span>
              {user?.permissions?.includes('update-role') &&
                <Tooltip title={'Edit'}>
                <IconButton 
                  onClick={() => props?.setRoleAction(CLICK_ACTIONS.EDIT_ROLE)}
                  disabled={!user?.permissions?.includes('update-role')}
                  className="role"
                >
                  <EditOutlinedIcon fontSize="small" className="edit-color"/>
                </IconButton>
                </Tooltip>
              }
              {user?.permissions?.includes('delete-role') &&
                <Tooltip title={'Delete'}  >
                <IconButton 
                  onClick={() => props?.setRoleAction(CLICK_ACTIONS.DELETE_ROLE)}
                  disabled={!user?.permissions?.includes('delete-role')}
                  
                >
                  <img 
                    src={require('../assets/img/delete.svg').default}
                    alt="Delete"
                    className="delete-icon"
                  />
                </IconButton> 
                </Tooltip>
              }
            </span>
          </>
        ) : headerItem.action === CLICK_ACTIONS.SELECT_GRIEVANCE ? (
          <div className="checkbox-container">
            <div className="checkbox-wrapper">
              <Input 
                type="checkbox" 
                className="custom-checkbox"
                checked={props?.selectedRows?.includes(item.grievanceId) && 
                        (!props?.deSelectClose || (props?.deSelectClose && item.status !== STATUS.CLOSE))}
                readOnly={(props?.deSelectClose && item.status === STATUS.CLOSE)}
                disabled={(props?.selectedLOB && item.lobId !== props?.selectedLOB && item.status !== STATUS.CLOSE)}
                onChange={() => handleSelectRow(item.grievanceId)}
              />
              {props?.deSelectClose && item.status === STATUS.CLOSE && 
                <label style={{color: "#ffff"}} className="tooltip-text">Cannot select a closed ticket</label>
              }
            </div>
          </div>
        ) : (
            <span className="td-span w-100">
              {findValue(headerItem, item, props?.masterData)}
            </span>
          )
        }
      </>
    );
  };

  return (
    <div>
      <Table 
        striped 
        hover
        responsive={props?.responsive} 
        className={props?.responsive && 'table-responsive'}
        style={{ marginTop: '2%', marginBottom: '75px' }}
      >
        <thead className="sticky-header">
          <tr className="aligne-center">
            {props.columnHeaders.map((headers : any, i: number)=>{
              return (
                <th key={headers.name}>
                  <div className="d-flex flex-row align-items-center ">
                    {headers?.checkbox ?
                      <div className="checkbox-container">
                        <Input 
                          type="checkbox"
                          className="custom-checkbox"
                          checked={props?.selectAll}
                          onChange={handleSelectAll}
                        />
                      </div>
                      :
                      <>
                        {headers.name}
                        {headers?.searchable &&
                          <Dropdown isOpen={dropdownOpen[headers.field]} toggle={() => toggleDropdown(headers.field)} className="ms-2">
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen[headers.field]}>
                              <img src={require('../assets/img/sort.svg').default} alt="search icon" />
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-search">
                              <Input
                                type="text"
                                placeholder={`${headers.name}`}
                                value={(props?.searchTerms[headers.field] || '').replace(/#/g, '')}
                                onChange={(e) => handleSearch(e, headers.field)}
                                onKeyDown={handleKeyDown}
                                style={{fontSize:'12px'}}
                              />
                            </DropdownMenu>
                          </Dropdown>
                        }
                      </>
                    }
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody >
          {props?.data?.map((each: any, i: number) => {
            return (
              <tr 
                className={(each.slNo % 2 == 0) ? "aligne-center" : "data-background"}
                key={`${i}`}
              >
                {props.columnHeaders.map(
                    (headerItem: ColumnHeaderType, headerIndex: number) => (
                      <td
                        key={`td${headerItem.field}_${headerIndex}`}
                        className={` ${getTableItemClickClass(each, headerItem)}
                          ${
                            headerItem.classNameGetter
                              ? headerItem.classNameGetter(
                                  each,
                                  headerItem.field
                                )
                              : ''
                          }`}
                        onClick={() => {
                          (headerItem.action ?? headerItem.actionGetter) &&
                            headerItem.clickable &&
                            props.onAction(each, headerItem);
                        }}
                      >
                        {getTableTd(headerItem, each)}
                      </td>
                    )
                  )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default TableComponent;